module.exports = __webpack_public_path__ + "assets/img/c2a0-li.svg";